// Import and register all your controllers

import { application } from "./application"

// Eager load all controllers with Vite's glob import
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })

for (const path in controllers) {
  const module = controllers[path]
  const name = path
    .replace(/^\.\//, '')
    .replace(/\//g, '--')
    .replace(/_controller\.js$/, '')
    .replace(/_/g, '-')

  application.register(name, module.default)
}